import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TreoMediaWatcherService } from 'tsui/@treo';

@Component({
  selector: 'account-functions',
  templateUrl: './account-functions.component.html',
  styleUrls: ['./account-functions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountFunctionsComponent implements OnInit, OnDestroy {
  @ViewChild('drawer')
  drawer: MatDrawer;

  drawerMode: 'over' | 'side';
  drawerOpened: boolean;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {TreoMediaWatcherService} _treoMediaWatcherService
   */
  constructor(private _treoMediaWatcherService: TreoMediaWatcherService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.drawerMode = 'side';
    this.drawerOpened = true;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {}

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
